<div class="sections">
    <app-pilots-group [group]="form().controls.flight" [lookups]="lookups()"></app-pilots-group>
    <app-crew-members-group [rows]="form().controls.crews" [lookups]="lookups()" [members]="members()"></app-crew-members-group>
    <app-passengers-group [group]="form().controls.flight"></app-passengers-group>
</div>
